export function checkboxConfig({ colors }) {
    return {
        readOnly: {
            border: `1px solid ${colors.graphicSecondaryColorLight}`,
            checkedBG: colors.graphicSecondaryColorLight
        }
    };
}
